export enum ProfessionalsAction {
  GET_PROFESSIONALS_SUCCESS = 'GET_PROFESSIONALS_SUCCESS',
  UPDATE_PROFESSIONAL_STATUS_SUCCESS = 'UPDATE_PROFESSIONAL_STATUS_SUCCESS',
  DECLINE_PROFESSIONAL_SUCCESS = 'DECLINE_PROFESSIONAL_SUCCESS',
  DEACTIVATE_PROFESSIONAL = 'DEACTIVATE_PROFESSIONAL',
}
